import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { useStore } from '@stores';

const style = {
  padding: '0 0.9375rem',
  height: '3rem',
  borderBottom: '1px solid #e8e8e8',
  display: 'flex',
  flexShrink: 0,
  zIndex: 1002,
  '@media (max-width:960px)': {
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
    border: 'none',
  },
  alignItems: 'center',
};

export const BlacklistHeader = observer(() => {
  const { formStore, commonStore } = useStore();
  const { loading } = commonStore;
  const { exit } = formStore;

  const handleExit = () => {
    const data = { error: 'Blacklisted' };
    exit(data);
    formStore.setToggleRampingOff();
  };

  return (
    <Box sx={style} justifyContent={'end'} data-cy="BlacklistHeader">
      <IconButton
        size="small"
        sx={{
          width: '2rem',
          height: '2rem',
          visibility: !loading ? 'visible' : 'hidden',
          color: '#878787',
          '@media (max-width: 960px)': {
            color: '#878787',
          },
        }}
        onClick={() => handleExit()}
        aria-label="close-ec"
        data-cy="close-button"
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
});
